import useSWR from 'swr';
import { UnionFragment } from '@amf/shared/types/graphql';
import { useMemo } from 'react';

const PATH = '/api/player/unions';
const getKey = (id: string) => () => {
  const params = new URLSearchParams({ id });
  return `${PATH}?${params.toString()}`;
};

function usePlayerUnions(id: string) {
  const { data, error } = useSWR<UnionFragment[]>(getKey(id));
  const unions = useMemo(() => (data && Array.isArray(data) ? data : []), [data]);
  return {
    error,
    unions,
    loading: !data && !error,
  };
}

export default usePlayerUnions;
